import { useNavigate } from "react-router-dom";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../ui/table";
import { formatDate } from "../../lib/dateUtils";

const STATUS_STYLE = {
  "Fully Matched": "bg-midnight-black text-clean-white",
  "No Registrations": "bg-soft-gray text-midnight-black/60",
};

export const UpcomingSessionsTable = ({ sessions }) => {
  const navigate = useNavigate();

  if (sessions.length === 0) {
    return <p className="font-medium text-midnight-black/60" data-testid="no-upcoming-sessions">No upcoming sessions on the calendar.</p>;
  }

  return (
    <div className="border border-soft-gray rounded-2xl overflow-hidden" data-testid="upcoming-sessions-table">
      <Table>
        <TableHeader>
          <TableRow className="border-soft-gray">
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Date</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Session</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">City</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Photographer</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Type</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Participants</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Matching</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sessions.map((s) => (
            <TableRow
              key={s.id}
              onClick={() => navigate("/admin/sessions")}
              className="border-soft-gray cursor-pointer hover:bg-warm-white"
              data-testid={`upcoming-session-row-${s.id}`}
            >
              <TableCell className="font-bold text-xs whitespace-nowrap">{formatDate(s.session_date)}</TableCell>
              <TableCell className="font-bold text-xs">{s.title}</TableCell>
              <TableCell className="text-xs">{s.city}, {s.state}</TableCell>
              <TableCell className="text-xs">{s.photographer_name}</TableCell>
              <TableCell className="text-xs capitalize">{s.session_type}</TableCell>
              <TableCell className="text-xs">{s.participants}/{s.capacity}</TableCell>
              <TableCell>
                <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded-full ${STATUS_STYLE[s.matching_status] || "bg-stranger-orange text-clean-white"}`}>
                  {s.matching_status}
                </span>
              </TableCell>
              <TableCell className="text-xs font-bold uppercase">{s.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
